export const testimonials = [
  {
    text: 'Super tolle und kompetente Leute. Preis-Leistungsverhältnis im Vergleich zum Ergebnis absolut gerechtfertigt.',
    source: 'Google Rezension',
  },
  {
    text: 'Super Mensch, hilfsbereit und freundlich!',
    source: 'Google Rezension',
  },
  {
    text: 'Absolute Empfehlung!',
    source: 'Google Rezension',
  },
];